<template>
  <div>
    <slider :slider_images="slider_images"/>
    <v-row class="mt-5">
      <v-col cols="12" md="9">
        <recent-shipments :shipment_list="shipment_list"/>
      </v-col>
      <v-col class="pl-5" cols="12" md="3">
        <stats :over_view_data="over_view_data"/>
      </v-col>
    </v-row>

    <welcome-popup/>

    <account-block-dialog :is_bloked="is_bloked"/>
  </div>
</template>
<script type="text/javascript">
export default {
  components: {
    Slider: () => import('./child/Slider.vue'),
    RecentShipments: () => import('./child/RecentShipments.vue'),
    Stats: () => import('./child/Stats.vue'),
    WelcomePopup: () => import('@/components/common-components/WelcomePopup.vue'),
    AccountBlockDialog: () => import('@/components/common-components/AccountBlockDialog.vue'),
  },
  data() {
    return {
      shipment_list: [],
      slider_images: [],
      over_view_data: {
        out_for_delivery_count: 0,
        delivered_count: 0,
        new_order_count: 0,
        partial_returned_count: 0,
        picked_up_count: 0,
        returned_count: 0,
        to_be_returned_count: 0,
        wallet_amount: 0,
        is_active: true,
      },
      is_bloked: false,
    }
  },
  created() {
    this.$store.dispatch('drawer/setActiveTab', this.$route.name)
    this.getWholeSalerHomeData();
    this.getShipmentList();
  },
  methods: {
    /* fetch wholesaler details */
    getWholeSalerHomeData() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      let params = {};

      const successHandler = (response) => {
        console.log(response)
        self.over_view_data = response.data
        self.is_bloked = !response.data.is_active
        this.$store.dispatch('setNewNotificationCount', response.data.notification_count)
        // this.$store.dispatch('setNewNotificationCount', 2)


        self.slider_images = response.data.dashboard_image_list
      };
      const finallyHandler = () => {
        this.$store.dispatch('setPageLoader', false)

      };
      self.request_GET(self, self.$urls.WHOLESALER_HOME, params, successHandler, null, null, finallyHandler)

    },

    getShipmentList() {
      this.$store.dispatch('setPageLoader', true)
      const self = this
      let params = {
        page_number: 1,
        page_length: 5,
      };

      const successHandler = (response) => {
        console.log(response)
        if (response.data.success) {
          this.shipment_list = response.data.shipment_list
          this.total_page_count = response.data.total_page_count
        }
      };
      const finallyHandler = () => {
        self.table_loading = false
        this.$store.dispatch('setPageLoader', false)
      };
      self.request_GET(self, self.$urls.SHIPMENT_LIST, params, successHandler, null, null, finallyHandler)
    },


  }
}


</script>